import { jsx as e, jsxs as t, Fragment as Q } from "react/jsx-runtime";
import { useState as y } from "react";
import { Alert as k, AlertTitle as w, Stack as D, Box as c, Typography as g, Button as x } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import { g as C, D as T, b, u as Y, a as E, F as j } from "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import { qcesubjects as f } from "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { DaymapSkeleton as v } from "../skeletons/index.js";
import { QCEResultsTable as p } from "./QCEResults.js";
const ae = (i) => {
  const { isState: n, hasFeature: a, settings: s } = Y(), { isPending: u, error: m, data: d } = new f.HasQCETask({ studentId: i }).ToQuery({ enabled: !!i });
  return !u && !m && n(E.QLD) && a(j.Curriculum) && (s == null ? void 0 : s.showQceDashParentStudent) && d;
}, ue = ({ studentId: i, year: n }) => {
  const [a, s] = y(!1), [u, m] = y(!1), { isPending: d, error: h, data: r } = new f.StudentYear({ studentId: Number(i) }).ToQuery(), { isPending: F, error: S, data: o } = new f.TasksForStudent({ studentId: Number(i), year: Number(n) }).ToQuery();
  if (d || F)
    return /* @__PURE__ */ e(v, { type: "listitems" });
  if (h || S) {
    const l = h || S;
    if (l)
      return console.error("Error getting data", l), /* @__PURE__ */ t(k, { color: "error", children: [
        l.title && /* @__PURE__ */ e(w, { children: l.title }),
        l.detail
      ] });
  }
  return !r || !o ? null : /* @__PURE__ */ t(D, { gap: 0.5, children: [
    a && /* @__PURE__ */ e(C, { fullScreen: !0, showFullScreenControls: !0, title: "QCE Results", open: a, onClose: () => s(!1), maxWidth: !1, children: /* @__PURE__ */ e(p, { studentyear: 11, results: o, sx: { maxHeight: "70vh" } }) }),
    /* @__PURE__ */ t(c, { display: "flex", justifyContent: "space-between", alignItems: "end", children: [
      /* @__PURE__ */ t(g, { variant: "h3", children: [
        "Year  ",
        r,
        " ",
        r && Number(r) === 12 ? n - 1 : n
      ] }),
      /* @__PURE__ */ e(c, { display: "flex", gap: 1, alignSelf: "flex-end", children: /* @__PURE__ */ e(x, { startIcon: /* @__PURE__ */ e(T, { iconType: b.FullScreen }), onClick: () => s(!0), children: "Full screen" }) })
    ] }),
    /* @__PURE__ */ e(p, { studentyear: 11, results: o, sx: { maxHeight: "70vh" } }),
    r && Number(r) === 12 && /* @__PURE__ */ t(Q, { children: [
      u && /* @__PURE__ */ e(C, { fullScreen: !0, showFullScreenControls: !0, title: "QCE Results", open: u, onClose: () => m(!1), maxWidth: !1, children: /* @__PURE__ */ e(p, { studentyear: 12, results: o, sx: { maxHeight: "70vh" } }) }),
      /* @__PURE__ */ t(c, { display: "flex", justifyContent: "space-between", alignItems: "end", children: [
        /* @__PURE__ */ t(g, { variant: "h3", children: [
          "Year  ",
          r,
          " ",
          n
        ] }),
        /* @__PURE__ */ e(c, { display: "flex", gap: 1, alignSelf: "flex-end", children: /* @__PURE__ */ e(x, { startIcon: /* @__PURE__ */ e(T, { iconType: b.FullScreen }), onClick: () => m(!0), children: "Full screen" }) })
      ] }),
      /* @__PURE__ */ e(p, { studentyear: 12, results: o, sx: { maxHeight: "70vh" } })
    ] })
  ] });
};
export {
  ue as StudentQCESubjects,
  ae as useQCETab
};
//# sourceMappingURL=StudentQCESubjects.js.map
